import React, { useEffect, useState } from "react";
import SideBar from "../Sidebar/SideBar";
import PlanMasterApi from "../../Api/PlanMaster";
import { Icon } from "@iconify/react/dist/iconify.js";
import JoditEditor from "jodit-react";
import Swal from "sweetalert2";

const PlanMaster = () => {
    const [itemId, setitemId] = useState("");

    const [inputs, setInputs] = useState({
        PlanName: "",
        PlanDescription: "",
        Price: "",
        isActive: true,
    });

    const [data, setData] = useState([]);

    // ---------------- INPUT CHANGE ----------------
    const handleChange = (e) => {
        const { name, value } = e.target;

        setInputs((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ---------------- JODIT CHANGE ----------------
    const handleEditorChange = (newContent) => {
        setInputs((prev) => ({
            ...prev,
            PlanDescription: newContent,
        }));
    };

    // ---------------- FETCH ----------------
    const fetchData = async () => {
        const response = await PlanMasterApi.GetAllPlans();
        if (response?.IsSuccess) {
            setData(response.Result);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ---------------- SAVE ----------------
    const handleSave = async () => {
        const response = await PlanMasterApi.CreatePlan(inputs);

        if (response?.IsSuccess) {
            Swal.fire("Success", "Plan Created Successfully", "success");
            resetForm();
            fetchData();
        }
    };

    // ---------------- UPDATE ----------------
    const handleUpdate = async () => {
        const response = await PlanMasterApi.UpdatePlan(itemId, inputs);

        if (response?.IsSuccess) {
            Swal.fire("Updated", "Plan Updated Successfully", "info");
            setitemId("");
            resetForm();
            fetchData();
        }
    };

    // ---------------- EDIT ----------------
    const handleEdit = (item) => {
        setitemId(item.Id);

        setInputs({
            PlanName: item.PlanName,
            PlanDescription: item.PlanDescription,
            Price: item.Price,
            isActive: item.IsActive,
        });
    };

    // ---------------- DELETE ----------------
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this plan?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
        });

        if (!result.isConfirmed) return;

        const response = await PlanMasterApi.DeletePlan(id);

        if (response?.IsSuccess) {
            Swal.fire("Deleted", "Plan Deleted Successfully", "success");
            fetchData();
        }
    };

    // ---------------- RESET ----------------
    const resetForm = () => {
        setInputs({
            PlanName: "",
            PlanDescription: "",
            Price: "",
            isActive: true,
        });
    };

    return (
        <div className="Flex-general-client-sidebar">
            <div className="sidebar-gen-width">
                <SideBar />
            </div>

            <div className="Main-general-Client">

                <div className="header-general">
                    <h2 className="general-card-title">Plan Master</h2>
                </div>

                <div className="control_radius">

                    {/* ---------------- ROW 1 ---------------- */}
                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        type="text"
                                        name="PlanName"
                                        value={inputs.PlanName}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Plan Name</label>
                                </div>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        type="text"
                                        name="Price"
                                        value={inputs.Price}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Price</label>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* ---------------- JODIT EDITOR ---------------- */}
                    <div className="table-account-manager">
                        <JoditEditor
                            value={inputs.PlanDescription}
                            onChange={handleEditorChange}
                        />
                    </div>

                    {/* ---------------- STATUS ---------------- */}
                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <select
                                        className="modify_im_input mode_category1"
                                        name="isActive"
                                        value={inputs.isActive}
                                        onChange={handleChange}
                                    >
                                        <option value={true}>Active</option>
                                        <option value={false}>Inactive</option>
                                    </select>
                                    <label className="modify_p_text2">Status</label>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* ---------------- SAVE BUTTON ---------------- */}
                    <div className="ButtonTabSave">
                        {itemId ? (
                            <button
                                id="SaveBtnMain"
                                className="update-button-main-save hovered"
                                onClick={handleUpdate}
                            >
                                Update
                            </button>
                        ) : (
                            <button
                                id="SaveBtnMain"
                                className="save-button-main-save hovered"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}
                    </div>

                    {/* ---------------- TABLE ---------------- */}
                    <div className="company_info-text-im depart_top">
                        Plan List
                    </div>

                    <div className="control_radius">
                        <div className="table-account-manager">

                            <table className="table-master-acc">

                                {/* ---------------- HEADER ---------------- */}
                                <thead className="header-table-account">
                                    <tr>
                                        <th className="table-header-manager ac-sno-wth">S.No</th>
                                        <th className="table-header-manager">Plan Name</th>
                                        <th className="table-header-manager">Price</th>
                                        <th className="table-header-manager">Description</th>
                                        <th className="table-header-manager">Status</th>
                                        <th className="table-header-manager">Created On</th>
                                        <th className="table-header-manager">Actions</th>
                                    </tr>
                                </thead>

                                {/* ---------------- BODY ---------------- */}
                                <tbody>
                                    {data?.map((item, idx) => (
                                        <tr key={item.Id}>

                                            <td className="table-data-account ac-sno-wth">
                                                {idx + 1}
                                            </td>

                                            <td className="table-data-account">
                                                {item.PlanName}
                                            </td>

                                            <td className="table-data-account">
                                                {item.Price}
                                            </td>

                                            <td className="table-data-account">
                                                <div
                                                    style={{
                                                        maxWidth: "220px",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                    title={item.PlanDescription}
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.PlanDescription,
                                                    }}
                                                />
                                            </td>

                                            <td className="table-data-account">
                                                <span
                                                    style={{
                                                        padding: "4px 10px",
                                                        borderRadius: "6px",
                                                        fontSize: "12px",
                                                        color: "white",
                                                        backgroundColor: item.IsActive ? "green" : "red",
                                                    }}
                                                >
                                                    {item.IsActive ? "Active" : "Inactive"}
                                                </span>
                                            </td>

                                            <td className="table-data-account">
                                                {item.CreatedOn
                                                    ? new Date(item.CreatedOn).toLocaleDateString()
                                                    : "-"}
                                            </td>

                                            {/* ---------------- ACTIONS ---------------- */}
                                            <td className="table-data-account">

                                                <button
                                                    className="edit-btn-acc"
                                                    onClick={() => handleEdit(item)}
                                                >
                                                    <Icon icon="lucide:edit" />
                                                </button>

                                                <button
                                                    className="delete-btn-acc"
                                                    onClick={() => handleDelete(item.Id)}
                                                >
                                                    <Icon icon="material-symbols:delete" />
                                                </button>

                                            </td>

                                        </tr>
                                    ))}
                                </tbody>

                            </table>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PlanMaster;